import { useState } from 'react';
import { IconContrast, IconMoon, IconSun } from './Icons.jsx';
import { THEME_LABELS, getTheme, nextTheme, toggleTheme } from '../lib/theme.js';

const THEME_ICONS = { light: IconSun, dark: IconContrast, midnight: IconMoon };

/**
 * Cycles Light, Dark (black), Midnight (navy). The icon shows the theme that is
 * active now; the tooltip names the one you get next.
 */
export default function ThemeToggle({ className = 'btn btn-ghost btn-icon' }) {
  const [theme, setThemeState] = useState(getTheme);
  const Current = THEME_ICONS[theme] ?? IconContrast;
  const label = `Theme: ${THEME_LABELS[theme]}. Switch to ${THEME_LABELS[nextTheme(theme)]}`;

  return (
    <button
      type="button"
      className={className}
      onClick={() => setThemeState(toggleTheme())}
      data-tip={label}
      aria-label={label}
    >
      <Current />
    </button>
  );
}
